(function() {
  var $win, conf, dirName, resizeListener, win;

  win = window;

  $win = $(win);

  dirName = window.dirName;

  conf = {
    breakPoint: window[dirName + 'Param'].breakPoint,
    view: null
  };

  window.examConf = conf;

  resizeListener = {};

  $win.on('resize', (function() {
    var dist, first, resizeHandler, timer;
    timer = null;
    dist = 250;
    first = true;
    resizeHandler = function() {
      var key;
      conf.w = $win.width();
      conf.h = $win.height();
      conf.view = conf.breakPoint <= conf.w ? 'large' : 'small';
      if (!first) {
        for (key in resizeListener) {
          resizeListener[key](conf);
        }
      } else {
        first = false;
      }
    };
    resizeHandler();
    return function() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(resizeHandler, dist);
    };
  })());

  window.examResizeListener = resizeListener;

  (function() {
    var $body, $btn, view;
    $btn = $('.drower-btn a');
    $body = $('body');
    view = null;
    $btn.on('click', function(e) {
      view = 'small';
      e.preventDefault();
      if ($body.hasClass('drower-active')) {
        $body.removeClass('drower-active');
      } else {
        $body.addClass('drower-active');
      }
    });
    resizeListener.drower = function(conf) {
      if (conf.view !== view && conf.view === 'large') {
        view = conf.view;
        $body.removeClass('drower-active');
      }
    };
  })();

}).call(this);
